module.exports = __webpack_public_path__ + "media/components/util/logos/vecteezy-logo--mountain-0cbe0ad221e102e9e94cb2564477fb07.jpg";